import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "../reducers";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import apiMiddleware from "../middleware/notificationMiddleware";

const persistConfig = {
  key: "bhmm-hr-storage",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewareEnhancer = applyMiddleware(thunk, apiMiddleware);
const storeEnhancers = compose(middlewareEnhancer);

const store = createStore(persistedReducer, storeEnhancers);
const persistor = persistStore(store);

export { store, persistor };